import React from "react";
import { FaUserGraduate, FaGlobe,FaBook, FaPaperPlane  } from "react-icons/fa";
import whyImg from "../assets/why.png";

const WhyChoose = () => {
  return (
    <div className="why-section">

      <div className="why-box">

        {/* LEFT IMAGE */}
        <div className="why-left">
          <img
            src={whyImg}
            alt="Nav Jeevan Mission School"
          />
        </div>

        {/* RIGHT CONTENT */}
        <div className="why-right">

          <h2>WHY CHOOSE OUR SCHOOL?</h2>

          <p>
            A leading residential school focused on excellence,
            leadership and holistic development.
          </p>

          <div className="why-grid">

            <div className="why-item">
              <FaBook className="why-icon" />
              <div>
                <h3>Progressive Education</h3>
              </div>
            </div>

            <div className="why-item">
              <FaGlobe className="why-icon" />
              <div>
                <h3>Online SmartClass Education</h3>
                
              </div>
            </div>

            <div className="why-item">
              <FaPaperPlane className="why-icon" />
              <div>
                <h3>Excellent Infrastructure</h3>
              </div>
            </div>

            <div className="why-item">
              <FaUserGraduate className="why-icon" />
              <div>
                <h3>Shaping a Bright Future</h3>
              </div>
            </div>

          </div>

        </div>

      </div>

    </div>
  );
};

export default WhyChoose;